import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";

var PlaceHolderHelper =
/*#__PURE__*/
function () {
  function PlaceHolderHelper() {
    _classCallCheck(this, PlaceHolderHelper);
  }

  _createClass(PlaceHolderHelper, [{
    key: "TranslateAll",
    value: function TranslateAll(text, placeholders) {
      for (var key in placeholders) {
        text = this.Translate(text, key, placeholders[key]);
      }

      return text;
    }
  }, {
    key: "Translate",
    value: function Translate(text, placeholder, value) {
      return text.replace(new RegExp("{{".concat(placeholder, "}}"), "g"), value);
    }
  }]);

  return PlaceHolderHelper;
}();

export default new PlaceHolderHelper();